import { useSelector } from 'react-redux';
import { getPurchaseIdentifiers } from '../../selector';
import { IStore } from '../../../../store/interface';

export const usePurchaseIdentifiers = () => ({
  identifiers: useSelector<IStore, string[]>(getPurchaseIdentifiers),
});
